/* eslint-disable function-paren-newline */
/* eslint-disable implicit-arrow-linebreak */
import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import { Button, Icon, Modal, ModalFooter } from '@folio/stripes-components';
import { FormattedMessage, useIntl } from 'react-intl';
import { Form } from 'react-final-form';
import arrayMutators from 'final-form-arrays';
import { FieldArray } from 'react-final-form-arrays';
import DrivationOptions from './DrivationOptions';
import DrivedFieldsValues from './DrivedFieldsValues';

const propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  fieldData: PropTypes.object,
  fieldName: PropTypes.string,
  parentFields: PropTypes.object,
  parentFieldIndex: PropTypes.number,
};

function DriveNewFieldsModal({
  open,
  onClose,
  fieldData,
  fieldName,
  parentFields,
  parentFieldIndex,
}) {
  const { drivedFields, fieldArray, label } = fieldData;

  const { locale } = useIntl();
  const fieldLabel = label.find((field) => field.locale === locale)?.value;

  const onHandleSubmit = (values) => {
    const primaryList = values.availableLists.find(
      (list) => list.isPrimary === true,
    );

    const fieldSource = fieldArray.find(
      (data) => data.name === primaryList.name,
    );

    const drivedFieldsData = {
      drivedFrom: primaryList?.name,
      drivedFieldsValues: values.drivedFieldsValues,
      relatedTextField: values.relatedTextField,
      dataOptionsSource: fieldSource?.dataOptionsSource,
      // type: 'drivedField',
    };

    parentFields.update(parentFieldIndex, {
      ...parentFields.value[parentFieldIndex],
      drivedFields: drivedFieldsData.drivedFieldsValues
        ? drivedFieldsData
        : undefined,
    });
    onClose();
  };

  const renderFooter = (renderProps) => {
    return (
      <ModalFooter>
        <Button
          id="inventory-template-plugin-drive-new-fields-modal-footer-save-btn"
          buttonStyle="primary"
          type="submit"
          onClick={(event) => {
            renderProps.handleSubmit(event);
          }}
          disabled={renderProps.pristine || renderProps.submitting}
        >
          <FormattedMessage
            id="ui-plugin-inventory-templates.buttons.save"
            defaultMessage="Save"
          />
        </Button>
        <Button
          id="inventory-template-plugin-add-field-modal-footer-close-btn"
          buttonStyle="slim"
          onClick={onClose}
        >
          <Icon icon="times-circle-solid" size="large">
            <FormattedMessage id="stripes-core.button.close" />
          </Icon>
        </Button>
      </ModalFooter>
    );
  };

  const getAvailableLists = () => {
    return fieldArray?.filter((field) => field.type === 'select');
  };

  const getRelatedFields = () => {
    return fieldArray?.filter((field) => field.type === 'text');
  };

  const initRelatedTextField = () => {
    const relatedFields = getRelatedFields();

    return (
      drivedFields?.relatedTextField ||
      (relatedFields?.length ? relatedFields[0]?.name : '')
    );
  };

  const initAvailableLists = () => {
    const availableLists = [];
    const selectableFields = getAvailableLists();
    (selectableFields || []).forEach((field) => {
      if (drivedFields?.name === field.name) {
        availableLists.push({
          name: drivedFields.name,
          selectedValues: drivedFields.drivedFieldsValues.map((val) => ({
            value: val.value,
            label: val.name,
            name: val.name,
          })),
          isPrimary: true,
        });
      } else {
        availableLists.push({
          name: field.name,
          selectedValues: [],
          isPrimary: selectableFields.length === 1,
        });
      }
    });
    return availableLists;
  };

  const DrivedForm = (
    <Form
      onSubmit={onHandleSubmit}
      initialValues={{
        availableLists: initAvailableLists(),
        relatedTextField: initRelatedTextField(),
        drivedFieldsValues: fieldData?.drivedFields?.drivedFieldsValues,
      }}
      mutators={{
        ...arrayMutators,
      }}
      render={(renderProps) => {
        return (
          <form id="drive-new-fields-form" onSubmit={renderProps.handleSubmit}>
            <Modal
              id="inventory-template-plugin-drive-new-fields-modal"
              footer={renderFooter(renderProps)}
              open={open}
              onClose={onClose}
              dismissible
              label={
                <Icon icon="lightning">
                  <FormattedMessage
                    id="ui-plugin-inventory-templates.driveNewFieldsModal.label"
                    defaultMessage="Drive new fields from {fieldLabel} list"
                    values={{ fieldLabel }}
                  />
                </Icon>
              }
              size="large"
            >
              <DrivationOptions
                selectableFields={getAvailableLists()}
                fieldData={fieldData}
              />
              <FieldArray
                id={`template-drived-fields-editor-${fieldName}`}
                name="drivedFieldsValues"
                component={DrivedFieldsValues}
                fieldData={fieldData}
              />
              <hr />
              <pre>{JSON.stringify(renderProps.values, 0, 2)}</pre>
            </Modal>
          </form>
        );
      }}
    />
  );

  const container = document.getElementById('ModuleContainer');
  return ReactDOM.createPortal(DrivedForm, container, 'drive-new-fields-form');
}

DriveNewFieldsModal.propTypes = propTypes;

export default DriveNewFieldsModal;
